import Swiper from "swiper/bundle";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/zoom";

// 基本のスライダー
function new_swiper(swiperClassName) {
  // クラス名からセレクタを生成
  const swiperElement = document.querySelector(`.${swiperClassName}`);

  // セレクタが存在するか確認
  if (!swiperElement) {
    return;
  }

  // スマホ用ページネーションの幅を計算
  const paginationWidth = 270;
  // 「.swiper-wrapper」の要素の数を取得
  const wrapperElementsCount = swiperElement.querySelectorAll(".swiper-slide").length;
  // 横幅を計算
  const bulletWidth = paginationWidth / wrapperElementsCount;
  const bulletWidth_span = bulletWidth;

  // swiperElement内のスクロールバー要素を取得
  const scrollbarElement = swiperElement.querySelector(".swiper-scrollbar");

  // Swiperの初期化
  const mySwiper = new Swiper(swiperElement, {
    slidesPerGroup: 1,
    slidesPerView: 1,
    speed: 800,
    effect: "fade",
    autoplay: {
      delay: 4000,
    },
    observer: true,
    observeParents: true,
    loop: wrapperElementsCount > 1, // スライドが2つ以上ある場合にループを有効にする
    on: {
      init() {
        updateExtraPagination(this, swiperElement);
      },
      slideChange() {
        updateExtraPagination(this, swiperElement);
      },
    },
    pagination: {
      el: swiperElement.querySelector(".swiper-pagination"),
      renderBullet: function (index, className) {
        return (
          '<span class="' +
          className +
          '" style="width:' +
          bulletWidth_span +
          'px"></span>'
        );
      },
    },
    breakpoints: {
      769: {
        slidesPerView: 1,
        scrollbar: scrollbarElement
          ? {
              el: scrollbarElement,
              draggable: true,
            }
          : false,
      },
    },
  });
}

function updateExtraPagination(swiper, swiperElement) {
  // swiperElementの子要素から指定
  const paginationElement = swiperElement.querySelector(".swiper-pagination-extra");
  if (paginationElement) {
    const currentIndex = swiper.realIndex + 1;
    const totalSlides = swiper.slides.length;
    paginationElement.innerHTML =
      ("00" + currentIndex).slice(-2) +
      "<span> | </span>" +
      ("00" + totalSlides).slice(-2);
  } else {
    console.warn(".swiper-pagination-extra が見つかりません。");
  }
}

// 指定した要素のswiperを生成
document.addEventListener("DOMContentLoaded", () => {
  const swiperClasses = [
    "js-jpremium-room01",
    "js-jpremium-room02",
    "js-jpremium-room03",
    "js-jpremium-room04",
    "js-breakfast-point01",
    "js-breakfast-point03",
    "js-breakfast-point04",
    "js-dinner-point03",
  ];

  swiperClasses.forEach((swiperClass) => {
    const swiperElement = document.querySelector(`.${swiperClass}`);
    if (swiperElement) {
      new_swiper(swiperClass);
    }
  });
});
